import styled from 'styled-components'
import { belowContainer } from 'utilities/styled'
import TutorialBase from 'components/tutorial'
import CardListBase from 'components/card-list'

export const Tutorial = styled(TutorialBase)`
    margin-block-start: 32px;
`

export const containerProps = {
    name: 'surveys',
    breakpoint: 650
}

export const CardList = styled(CardListBase)`
    --__huma-component-surveys-grid:
        [symbol] 40px
        [meta] minmax(0, 3fr)
        [status] minmax(0, 1fr)
        [navigate] 24px;

    grid-template-columns: var(--__huma-component-surveys-grid);

    ${belowContainer(containerProps)`
        --__huma-component-surveys-grid:
            [symbol] 40px
            [meta] minmax(0, 1fr)
            [status] max-content
            [navigate] 24px;

        display: grid;
        column-gap: 16px;
    `}
`

export const CardListCell = styled(CardList.Cell)`
    ${({ $cell }) => $cell === 'name' && `
        grid-column: symbol / status;
    `}
`

export const LoadingContainer = styled.div`
    position: relative;

    display: grid;
    place-items: center;
    grid-columN: 1 / -1;

    height: 96px;
`